// estilos de la tabla

export const tableCustomStyles = {
  table: {
    style: {
      fontFamily: "Nunito !important",
    },
  },
  title: {
    style: {
      fontFamily: "Nunito !important",
    },
  },

  header: {
    style: {
      fontFamily: "Nunito !important",
      // minHeight: "56px",
    },
  },
  headRow: {
    style: {
      border: "solid 1px #F0292A",
      backgroundColor: "#F0292A",
      color: "#fff",
      fontFamily: "Nunito !important",
    },
  },
  headCells: {
    style: {
      fontFamily: "Nunito !important",
      //   "&:not(:last-of-type)": {
      //     borderRightStyle: "solid",
      //     borderRightWidth: "1px",
      //   },
    },
  },
  cells: {
    style: {
      fontFamily: "Nunito !important",
      //   "&:not(:last-of-type)": {
      //     borderRightStyle: "solid",
      //     borderRightWidth: "1px",
      //   },
    },
  },
};

export const customActionsLabels = {
  marginTop: "8px",
};

export const tableCustomStylesNP = {
  table: {
    style: {
      fontFamily: "Nunito !important",
      border: "none",
    },
  },
  title: {
    style: {
      fontFamily: "Nunito !important",
    },
  },

  header: {
    style: {
      fontFamily: "Nunito !important",
      // minHeight: "56px",
    },
  },
  headRow: {
    style: {
      border: "none",
      backgroundColor: "none",
      color: "#293134",
      fontFamily: "Nunito !important",
    },
  },
  headCells: {
    style: {
      fontFamily: "Nunito !important",
      //   "&:not(:last-of-type)": {
      //     borderRightStyle: "solid",
      //     borderRightWidth: "1px",
      //   },
    },
  },
  cells: {
    style: {
      fontFamily: "Nunito !important",
      //   "&:not(:last-of-type)": {
      //     borderRightStyle: "solid",
      //     borderRightWidth: "1px",
      //   },
    },
  },
};
